import React from 'react';
import Paragraph from './Paragraph';

export function ElementRenderer({ element, onChange, disabled, ...props }) {
  const sharedProps = { content: element.content, onChange, disabled };
  const baseType = element.type;
  switch (baseType) {
    case 'paragraph':
      return <Paragraph {...sharedProps} />;
    default: {
      return null;
    }
  }
}
